import React from "react";
import styled, { keyframes } from "styled-components";

import { Container, Content, TopBanner, AnimatedCard } from "../styles";
import LogoImage from "assets/images/Logo blue.png";

const epicIn = keyframes`
  0% { opacity: 0; transform: translateY(20px) scale(0.98); }
  60% { opacity: 1; transform: translateY(0) scale(1.02); }
  100% { opacity: 1; transform: translateY(0) scale(1); }
`;

const Center = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 320px;
  text-align: center;
  gap: 14px;
`;

const Title = styled.h1`
  font-family: 'Geist Variable', 'Geist', sans-serif;
  font-weight: 500;
  font-size: clamp(22px, 5vw, 26px);
  margin: 0;
  color: oklch(.145 0 0);
  line-height: 1.05;
  letter-spacing: 0.5px;
  animation: ${epicIn} 800ms ease-out both;
`;

const Description = styled.p`
  font-family: 'Geist Variable', 'Geist', sans-serif;
  font-size: clamp(15px, 2.2vw, 18px);
  color: #374151;
  margin: 10px 0 0 0;
  max-width: 560px;
`;

const Logo = styled.img`
  height: 30px;
  position: absolute;
  top: 20px;
  left: 20px;
`;

export default function InvalidToken({ themeColors }) {
  return (
    <Container themeColors={themeColors}>
      <TopBanner themeColors={themeColors}>
        <Logo src={LogoImage} alt="Logo" />
      </TopBanner>
      <Content>
        <AnimatedCard>
          <Center>
            <Title>Invalid or expired link</Title>
            <Description>
              We couldn’t get your information. Please check your link or contact your
              administrator for a new one.
            </Description>
          </Center>
        </AnimatedCard>
      </Content>
    </Container>
  );
}

